import * as React from 'react';
import {Container} from '../grid/container';
import {BubbleAnim} from './online-marketing/bubble-anim';
import './style.scss';
import {Translation} from "../../lang";

export class MarketingComponent extends React.Component<any, any> {
    public bubbleInstance;

    componentDidMount(): void {
        this.bubbleInstance = new BubbleAnim('bubbleAnim');
    }

    componentWillUnmount(): void {
        this.bubbleInstance.destroy();
    }

    render() {
        return <Container className="marketingComponent">

            <div id="bubbleAnim"/>

            <div className="container">
                <div
                    className="col-12 MS text-white text-center d-flex align-items-center justify-content-center flex-column">

                    <div className="col-12 col-sm-10 col-md-10 col-lg-8 col-xl-5 content-height d-inline-block">
                        <h1 className="fw-bold fst-italic">{Translation.get('marketing.title')}</h1>
                        <p className="fst-italic"> {Translation.get('marketing.description')}</p>
                    </div>

                </div>
            </div>

        </Container>;
    }
}
